var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoStationnement({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    zoomAndPan: "magnify",
    viewBox: "0 0 375 374.999991",
    height: 500,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "8591b11679"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 142.175781 92.15625 L 170 92.15625 L 170 119.703125 L 142.175781 119.703125 Z M 142.175781 92.15625 "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "821fe50ce5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 148.796875 110.210938 L 148.859375 98.464844 L 160.140625 98.289062 Z M 166.199219 92.34375 L 142.777344 92.289062 L 142.664062 115.828125 L 147.054688 119.472656 L 169.78125 96.742188 Z M 166.199219 92.34375 "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "13e4c096a6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 204.429688 92 L 231.972656 92 L 231.972656 119.152344 L 204.429688 119.152344 Z M 204.429688 92 "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "7ea3d3c2cb"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 213.78125 98.195312 L 225.523438 98.214844 L 225.734375 109.496094 Z M 231.699219 115.542969 L 231.6875 92.121094 L 208.148438 92.082031 L 204.515625 96.492188 L 227.308594 119.148438 Z M 231.699219 115.542969 "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "8393e8b967"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 204.429688 154 L 231.972656 154 L 231.972656 181.402344 L 204.429688 181.402344 Z M 204.429688 154 "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "90cc1ebfbb"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 225.605469 163.332031 L 225.554688 175.078125 L 214.273438 175.253906 Z M 208.203125 181.199219 L 231.625 181.253906 L 231.742188 157.714844 L 227.351562 154.070312 L 204.621094 176.800781 Z M 208.203125 181.199219 "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: 4013613400
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 142.175781 154 L 170 154 L 170 181.953125 L 142.175781 181.953125 Z M 142.175781 154 "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a05647cd8a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 160.632812 175.347656 L 148.890625 175.328125 L 148.679688 164.058594 Z M 142.707031 158.007812 L 142.714844 181.429688 L 166.253906 181.472656 L 169.886719 177.0625 L 147.09375 154.40625 Z M 142.707031 158.007812 "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "0650b26240"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 168.070312 71.222656 L 206.632812 71.222656 L 206.632812 127.414062 L 168.070312 127.414062 Z M 168.070312 71.222656 "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "927ef27039"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 202.207031 86.828125 L 198.394531 90.640625 L 187.386719 79.632812 L 180.464844 86.554688 L 206.617188 112.707031 L 192.289062 127.035156 L 182.597656 127.035156 L 168.375 112.8125 L 176.441406 104.746094 L 180.421875 108.726562 L 176.285156 112.867188 L 187.28125 123.441406 L 196.976562 114.292969 L 197.195312 111.785156 L 172.292969 86.882812 L 187.660156 71.515625 Z M 202.207031 86.828125 "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cb0cd4c986"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 197.269531 117.496094 L 253 117.496094 L 253 156.0625 L 197.269531 156.0625 Z M 197.269531 117.496094 "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "29c1f1c9d2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 237.601562 151.601562 L 233.789062 147.789062 L 244.796875 136.78125 L 237.875 129.859375 L 211.710938 156.011719 L 197.382812 141.6875 L 197.382812 131.992188 L 211.617188 117.761719 L 219.683594 125.828125 L 215.703125 129.808594 L 211.5625 125.667969 L 200.988281 136.667969 L 210.136719 146.371094 L 212.644531 146.59375 L 237.546875 121.699219 L 252.914062 137.066406 Z M 237.601562 151.601562 "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "9b1fec5206"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 168.070312 146.144531 L 206.632812 146.144531 L 206.632812 202.335938 L 168.070312 202.335938 Z M 168.070312 146.144531 "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "672f7ab6be"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 172.785156 186.734375 L 176.597656 182.921875 L 187.605469 193.929688 L 194.527344 187.007812 L 168.375 160.855469 L 182.710938 146.519531 L 192.40625 146.519531 L 206.628906 160.738281 L 198.5625 168.804688 L 194.582031 164.824219 L 198.71875 160.6875 L 187.722656 150.121094 L 178.027344 159.269531 L 177.808594 161.78125 L 202.710938 186.683594 L 187.34375 202.046875 Z M 172.785156 186.734375 "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "dfb7c18ed1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 122 117.496094 L 177.984375 117.496094 L 177.984375 156 L 122 156 Z M 122 117.496094 "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ba6d279379"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 137.402344 121.953125 L 141.214844 125.765625 L 130.207031 136.773438 L 137.128906 143.691406 L 163.292969 117.539062 L 177.605469 131.878906 L 177.605469 141.570312 L 163.386719 155.792969 L 155.320312 147.726562 L 159.300781 143.746094 L 163.4375 147.882812 L 174.015625 136.886719 L 164.867188 127.183594 L 162.355469 126.960938 L 137.453125 151.863281 L 122.085938 136.5 Z M 137.402344 121.953125 "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ef50f2a348"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 183.496094 133 L 191 133 L 191 140.636719 L 183.496094 140.636719 Z M 183.496094 133 "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "278409d6d6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 190.683594 140.175781 L 183.6875 140.175781 L 183.6875 133.167969 L 190.695312 133.167969 Z M 190.683594 140.175781 "
  })))), /*#__PURE__*/React.createElement("g", {
    id: "bde67082af"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 375,
    y: 0,
    height: 374.999991,
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 375,
    y: 0,
    height: 374.999991,
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#000000",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(17.795358, 244.572796)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 6.578125 0.328125 C 5.503906 0.328125 4.546875 0.148438 3.703125 -0.203125 C 2.867188 -0.566406 2.164062 -1 1.59375 -1.5 C 1.03125 -2 0.617188 -2.476562 0.359375 -2.9375 L 2.90625 -5.03125 C 3.039062 -4.84375 3.285156 -4.570312 3.640625 -4.21875 C 4.003906 -3.875 4.441406 -3.5625 4.953125 -3.28125 C 5.460938 -3.007812 6.003906 -2.875 6.578125 -2.875 C 7.578125 -2.875 8.378906 -3.101562 8.984375 -3.5625 C 9.597656 -4.019531 9.90625 -4.71875 9.90625 -5.65625 C 9.90625 -6.332031 9.722656 -6.929688 9.359375 -7.453125 C 9.003906 -7.984375 8.328125 -8.648438 7.328125 -9.453125 C 6.828125 -9.867188 6.351562 -10.265625 5.90625 -10.640625 C 5.457031 -11.023438 5.046875 -11.359375 4.671875 -11.640625 C 3.453125 -12.671875 2.585938 -13.671875 2.078125 -14.640625 C 1.566406 -15.609375 1.3125 -16.71875 1.3125 -17.96875 C 1.3125 -19.09375 1.566406 -20.085938 2.078125 -20.953125 C 2.585938 -21.816406 3.300781 -22.5 4.21875 -23 C 5.132812 -23.5 6.179688 -23.75 7.359375 -23.75 C 8.390625 -23.726562 9.398438 -23.539062 10.390625 -23.1875 C 11.378906 -22.84375 12.179688 -22.453125 12.796875 -22.015625 L 12.796875 -16.328125 L 9.421875 -16.328125 L 9.421875 -20.0625 C 9.179688 -20.207031 8.863281 -20.316406 8.46875 -20.390625 C 8.082031 -20.472656 7.703125 -20.523438 7.328125 -20.546875 C 6.585938 -20.546875 6 -20.328125 5.5625 -19.890625 C 5.125 -19.453125 4.90625 -18.851562 4.90625 -18.09375 C 4.90625 -17.3125 5.066406 -16.65625 5.390625 -16.125 C 5.722656 -15.601562 6.25 -15.050781 6.96875 -14.46875 C 7.40625 -14.113281 7.847656 -13.753906 8.296875 -13.390625 C 8.742188 -13.035156 9.21875 -12.660156 9.71875 -12.265625 C 10.738281 -11.484375 11.523438 -10.742188 12.078125 -10.046875 C 12.640625 -9.347656 13.023438 -8.65625 13.234375 -7.96875 C 13.441406 -7.28125 13.535156 -6.53125 13.515625 -5.71875 C 13.492188 -3.800781 12.84375 -2.3125 11.5625 -1.25 C 10.289062 -0.195312 8.628906 0.328125 6.578125 0.328125 Z M 6.578125 0.328125 "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#000000",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(32.745324, 244.572796)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 13.375 -20.25 L 5.921875 -20.25 L 5.921875 -13.734375 L 12.765625 -13.734375 L 12.765625 -10.53125 L 5.921875 -10.53125 L 5.921875 -3.203125 L 13.375 -3.203125 L 13.375 0 L 2.296875 0 L 2.296875 -23.453125 L 13.375 -23.453125 Z M 13.375 -20.25 "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#000000",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(47.204585, 244.572796)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 11.90625 0 L 7.59375 -9.296875 C 7.332031 -9.316406 7.0625 -9.347656 6.78125 -9.390625 C 6.507812 -9.429688 6.234375 -9.472656 5.953125 -9.515625 L 5.953125 0 L 2.296875 0 L 2.296875 -23.453125 L 8.25 -23.453125 C 10.125 -23.453125 11.613281 -22.921875 12.71875 -21.859375 C 13.832031 -20.804688 14.390625 -19.410156 14.390625 -17.671875 L 14.390625 -15.109375 C 14.390625 -13.910156 14.125 -12.859375 13.59375 -11.953125 C 13.0625 -11.046875 12.304688 -10.363281 11.328125 -9.90625 L 15.96875 0 Z M 5.953125 -20.25 L 5.953125 -12.828125 C 6.785156 -12.648438 7.484375 -12.5625 8.046875 -12.5625 C 8.984375 -12.5625 9.664062 -12.78125 10.09375 -13.21875 C 10.519531 -13.65625 10.734375 -14.3125 10.734375 -15.1875 L 10.734375 -17.640625 C 10.734375 -18.535156 10.535156 -19.191406 10.140625 -19.609375 C 9.742188 -20.035156 9.113281 -20.25 8.25 -20.25 Z M 5.953125 -20.25 "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#000000",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(62.972212, 244.572796)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 11.640625 -23.453125 L 15.375 -23.453125 L 9.546875 0 L 6.484375 0 L 0.65625 -23.453125 L 4.3125 -23.453125 L 7.328125 -10.234375 L 8.046875 -5.859375 L 8.734375 -10.234375 Z M 11.640625 -23.453125 "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#000000",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(79.001705, 244.572796)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 2.296875 0.03125 L 2.296875 -23.453125 L 5.953125 -23.453125 L 5.953125 0.03125 Z M 2.296875 0.03125 "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#000000",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(87.21273, 244.572796)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 12.828125 -4.25 L 14.421875 -1.609375 C 13.753906 -1.054688 12.90625 -0.59375 11.875 -0.21875 C 10.851562 0.144531 9.894531 0.328125 9 0.328125 C 6.53125 0.328125 4.707031 -0.195312 3.53125 -1.25 C 2.351562 -2.3125 1.765625 -3.707031 1.765625 -5.4375 L 1.765625 -18 C 1.765625 -19.71875 2.316406 -21.101562 3.421875 -22.15625 C 4.523438 -23.21875 6.132812 -23.75 8.25 -23.75 C 9.46875 -23.75 10.546875 -23.59375 11.484375 -23.28125 C 12.421875 -22.96875 13.257812 -22.546875 14 -22.015625 L 14 -16.5625 L 10.59375 -16.5625 L 10.59375 -20.125 C 10.207031 -20.226562 9.804688 -20.320312 9.390625 -20.40625 C 8.972656 -20.5 8.566406 -20.546875 8.171875 -20.546875 C 6.347656 -20.546875 5.4375 -19.675781 5.4375 -17.9375 L 5.4375 -5.5 C 5.4375 -4.625 5.789062 -3.96875 6.5 -3.53125 C 7.207031 -3.09375 8.039062 -2.875 9 -2.875 C 9.476562 -2.875 9.96875 -2.957031 10.46875 -3.125 C 10.96875 -3.289062 11.429688 -3.484375 11.859375 -3.703125 C 12.285156 -3.921875 12.609375 -4.101562 12.828125 -4.25 Z M 12.828125 -4.25 "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#000000",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(102.587965, 244.572796)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 13.375 -20.25 L 5.921875 -20.25 L 5.921875 -13.734375 L 12.765625 -13.734375 L 12.765625 -10.53125 L 5.921875 -10.53125 L 5.921875 -3.203125 L 13.375 -3.203125 L 13.375 0 L 2.296875 0 L 2.296875 -23.453125 L 13.375 -23.453125 Z M 13.375 -20.25 "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#000000",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(117.047226, 244.572796)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: ""
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#000000",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(123.982429, 244.572796)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 8.40625 -23.453125 C 10.28125 -23.453125 11.769531 -22.925781 12.875 -21.875 C 13.976562 -20.832031 14.53125 -19.429688 14.53125 -17.671875 L 14.53125 -5.796875 C 14.53125 -4.046875 13.976562 -2.640625 12.875 -1.578125 C 11.769531 -0.523438 10.28125 0 8.40625 0 L 2.296875 0 L 2.296875 -23.453125 Z M 10.859375 -5.828125 L 10.859375 -17.640625 C 10.859375 -18.535156 10.664062 -19.191406 10.28125 -19.609375 C 9.90625 -20.035156 9.28125 -20.25 8.40625 -20.25 L 5.921875 -20.25 L 5.921875 -3.203125 L 8.40625 -3.203125 C 9.28125 -3.203125 9.90625 -3.414062 10.28125 -3.84375 C 10.664062 -4.269531 10.859375 -4.929688 10.859375 -5.828125 Z M 10.859375 -5.828125 "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#000000",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(140.273639, 244.572796)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 13.375 -20.25 L 5.921875 -20.25 L 5.921875 -13.734375 L 12.765625 -13.734375 L 12.765625 -10.53125 L 5.921875 -10.53125 L 5.921875 -3.203125 L 13.375 -3.203125 L 13.375 0 L 2.296875 0 L 2.296875 -23.453125 L 13.375 -23.453125 Z M 13.375 -20.25 "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#000000",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(154.732899, 244.572796)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: ""
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#000000",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(161.668103, 244.572796)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 6.578125 0.328125 C 5.503906 0.328125 4.546875 0.148438 3.703125 -0.203125 C 2.867188 -0.566406 2.164062 -1 1.59375 -1.5 C 1.03125 -2 0.617188 -2.476562 0.359375 -2.9375 L 2.90625 -5.03125 C 3.039062 -4.84375 3.285156 -4.570312 3.640625 -4.21875 C 4.003906 -3.875 4.441406 -3.5625 4.953125 -3.28125 C 5.460938 -3.007812 6.003906 -2.875 6.578125 -2.875 C 7.578125 -2.875 8.378906 -3.101562 8.984375 -3.5625 C 9.597656 -4.019531 9.90625 -4.71875 9.90625 -5.65625 C 9.90625 -6.332031 9.722656 -6.929688 9.359375 -7.453125 C 9.003906 -7.984375 8.328125 -8.648438 7.328125 -9.453125 C 6.828125 -9.867188 6.351562 -10.265625 5.90625 -10.640625 C 5.457031 -11.023438 5.046875 -11.359375 4.671875 -11.640625 C 3.453125 -12.671875 2.585938 -13.671875 2.078125 -14.640625 C 1.566406 -15.609375 1.3125 -16.71875 1.3125 -17.96875 C 1.3125 -19.09375 1.566406 -20.085938 2.078125 -20.953125 C 2.585938 -21.816406 3.300781 -22.5 4.21875 -23 C 5.132812 -23.5 6.179688 -23.75 7.359375 -23.75 C 8.390625 -23.726562 9.398438 -23.539062 10.390625 -23.1875 C 11.378906 -22.84375 12.179688 -22.453125 12.796875 -22.015625 L 12.796875 -16.328125 L 9.421875 -16.328125 L 9.421875 -20.0625 C 9.179688 -20.207031 8.863281 -20.316406 8.46875 -20.390625 C 8.082031 -20.472656 7.703125 -20.523438 7.328125 -20.546875 C 6.585938 -20.546875 6 -20.328125 5.5625 -19.890625 C 5.125 -19.453125 4.90625 -18.851562 4.90625 -18.09375 C 4.90625 -17.3125 5.066406 -16.65625 5.390625 -16.125 C 5.722656 -15.601562 6.25 -15.050781 6.96875 -14.46875 C 7.40625 -14.113281 7.847656 -13.753906 8.296875 -13.390625 C 8.742188 -13.035156 9.21875 -12.660156 9.71875 -12.265625 C 10.738281 -11.484375 11.523438 -10.742188 12.078125 -10.046875 C 12.640625 -9.347656 13.023438 -8.65625 13.234375 -7.96875 C 13.441406 -7.28125 13.535156 -6.53125 13.515625 -5.71875 C 13.492188 -3.800781 12.84375 -2.3125 11.5625 -1.25 C 10.289062 -0.195312 8.628906 0.328125 6.578125 0.328125 Z M 6.578125 0.328125 "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#000000",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(175.963645, 244.572796)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 14.265625 -23.453125 L 14.265625 -20.25 L 9.296875 -20.25 L 9.296875 0 L 5.625 0 L 5.625 -20.25 L 0.65625 -20.25 L 0.65625 -23.453125 Z M 14.265625 -23.453125 "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#000000",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(187.903242, 244.572796)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 12.140625 0 L 11 -4.90625 L 5.296875 -4.90625 L 4.15625 0 L 0.484375 0 L 6.609375 -23.453125 L 9.6875 -23.453125 L 15.828125 0 Z M 6.046875 -8.140625 L 10.203125 -8.140625 L 8.671875 -14.75 C 8.554688 -15.164062 8.457031 -15.609375 8.375 -16.078125 C 8.289062 -16.546875 8.203125 -17.03125 8.109375 -17.53125 C 8.046875 -17.050781 7.96875 -16.578125 7.875 -16.109375 C 7.789062 -15.640625 7.695312 -15.210938 7.59375 -14.828125 Z M 6.046875 -8.140625 "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#000000",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(201.282229, 244.572796)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 14.265625 -23.453125 L 14.265625 -20.25 L 9.296875 -20.25 L 9.296875 0 L 5.625 0 L 5.625 -20.25 L 0.65625 -20.25 L 0.65625 -23.453125 Z M 14.265625 -23.453125 "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#000000",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(216.166758, 244.572796)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 2.296875 0.03125 L 2.296875 -23.453125 L 5.953125 -23.453125 L 5.953125 0.03125 Z M 2.296875 0.03125 "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#000000",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(224.377783, 244.572796)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 7.984375 0.328125 C 6.109375 0.328125 4.601562 -0.195312 3.46875 -1.25 C 2.332031 -2.3125 1.765625 -3.71875 1.765625 -5.46875 L 1.765625 -17.96875 C 1.765625 -19.707031 2.332031 -21.101562 3.46875 -22.15625 C 4.601562 -23.21875 6.109375 -23.75 7.984375 -23.75 C 9.265625 -23.75 10.382812 -23.507812 11.34375 -23.03125 C 12.3125 -22.550781 13.0625 -21.875 13.59375 -21 C 14.125 -20.132812 14.390625 -19.125 14.390625 -17.96875 L 14.390625 -5.46875 C 14.390625 -4.332031 14.125 -3.328125 13.59375 -2.453125 C 13.0625 -1.578125 12.3125 -0.894531 11.34375 -0.40625 C 10.382812 0.0820312 9.265625 0.328125 7.984375 0.328125 Z M 7.984375 -2.875 C 8.941406 -2.875 9.632812 -3.097656 10.0625 -3.546875 C 10.488281 -3.992188 10.703125 -4.644531 10.703125 -5.5 L 10.703125 -17.9375 C 10.703125 -18.78125 10.488281 -19.425781 10.0625 -19.875 C 9.632812 -20.320312 8.941406 -20.546875 7.984375 -20.546875 C 6.304688 -20.546875 5.46875 -19.675781 5.46875 -17.9375 L 5.46875 -5.5 C 5.46875 -3.75 6.304688 -2.875 7.984375 -2.875 Z M 7.984375 -2.875 "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#000000",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(240.538134, 244.572796)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 11.78125 -23.453125 L 15.34375 -23.453125 L 15.34375 0 L 11.8125 0 L 6.765625 -12.53125 C 6.554688 -13.050781 6.351562 -13.679688 6.15625 -14.421875 C 5.957031 -15.171875 5.789062 -15.863281 5.65625 -16.5 C 5.53125 -17.144531 5.445312 -17.566406 5.40625 -17.765625 L 5.796875 -13.015625 L 5.796875 0 L 2.296875 0 L 2.296875 -23.453125 L 6.3125 -23.453125 L 10.890625 -11.390625 C 11.046875 -10.992188 11.191406 -10.523438 11.328125 -9.984375 C 11.472656 -9.453125 11.601562 -8.929688 11.71875 -8.421875 C 11.84375 -7.910156 11.941406 -7.46875 12.015625 -7.09375 C 12.097656 -6.726562 12.140625 -6.515625 12.140625 -6.453125 L 11.78125 -11.1875 Z M 11.78125 -23.453125 "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#000000",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(258.13786, 244.572796)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 11.78125 -23.453125 L 15.34375 -23.453125 L 15.34375 0 L 11.8125 0 L 6.765625 -12.53125 C 6.554688 -13.050781 6.351562 -13.679688 6.15625 -14.421875 C 5.957031 -15.171875 5.789062 -15.863281 5.65625 -16.5 C 5.53125 -17.144531 5.445312 -17.566406 5.40625 -17.765625 L 5.796875 -13.015625 L 5.796875 0 L 2.296875 0 L 2.296875 -23.453125 L 6.3125 -23.453125 L 10.890625 -11.390625 C 11.046875 -10.992188 11.191406 -10.523438 11.328125 -9.984375 C 11.472656 -9.453125 11.601562 -8.929688 11.71875 -8.421875 C 11.84375 -7.910156 11.941406 -7.46875 12.015625 -7.09375 C 12.097656 -6.726562 12.140625 -6.515625 12.140625 -6.453125 L 11.78125 -11.1875 Z M 11.78125 -23.453125 "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#000000",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(275.737585, 244.572796)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 13.375 -20.25 L 5.921875 -20.25 L 5.921875 -13.734375 L 12.765625 -13.734375 L 12.765625 -10.53125 L 5.921875 -10.53125 L 5.921875 -3.203125 L 13.375 -3.203125 L 13.375 0 L 2.296875 0 L 2.296875 -23.453125 L 13.375 -23.453125 Z M 13.375 -20.25 "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#000000",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(290.196845, 244.572796)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 13.421875 -23.453125 L 17.765625 -23.453125 L 17.765625 0 L 14.140625 0 L 14.140625 -14 C 14.140625 -14.195312 14.15625 -14.515625 14.1875 -14.953125 C 14.21875 -15.390625 14.257812 -15.832031 14.3125 -16.28125 C 14.363281 -16.726562 14.398438 -17.082031 14.421875 -17.34375 C 14.359375 -17.082031 14.238281 -16.664062 14.0625 -16.09375 C 13.894531 -15.53125 13.664062 -14.832031 13.375 -14 C 13.007812 -13.0625 12.660156 -12.125 12.328125 -11.1875 C 12.003906 -10.25 11.65625 -9.3125 11.28125 -8.375 L 8.671875 -8.375 C 8.316406 -9.3125 7.992188 -10.25 7.703125 -11.1875 C 7.410156 -12.125 7.078125 -13.0625 6.703125 -14 C 6.421875 -14.832031 6.1875 -15.523438 6 -16.078125 C 5.8125 -16.640625 5.6875 -17.0625 5.625 -17.34375 C 5.664062 -17.082031 5.707031 -16.726562 5.75 -16.28125 C 5.800781 -15.832031 5.84375 -15.394531 5.875 -14.96875 C 5.90625 -14.539062 5.921875 -14.226562 5.921875 -14.03125 L 5.921875 0 L 2.296875 0 L 2.296875 -23.453125 L 6.640625 -23.453125 L 10.015625 -13.609375 Z M 13.421875 -23.453125 "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#000000",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(310.250084, 244.572796)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 13.375 -20.25 L 5.921875 -20.25 L 5.921875 -13.734375 L 12.765625 -13.734375 L 12.765625 -10.53125 L 5.921875 -10.53125 L 5.921875 -3.203125 L 13.375 -3.203125 L 13.375 0 L 2.296875 0 L 2.296875 -23.453125 L 13.375 -23.453125 Z M 13.375 -20.25 "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#000000",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(324.709344, 244.572796)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 11.78125 -23.453125 L 15.34375 -23.453125 L 15.34375 0 L 11.8125 0 L 6.765625 -12.53125 C 6.554688 -13.050781 6.351562 -13.679688 6.15625 -14.421875 C 5.957031 -15.171875 5.789062 -15.863281 5.65625 -16.5 C 5.53125 -17.144531 5.445312 -17.566406 5.40625 -17.765625 L 5.796875 -13.015625 L 5.796875 0 L 2.296875 0 L 2.296875 -23.453125 L 6.3125 -23.453125 L 10.890625 -11.390625 C 11.046875 -10.992188 11.191406 -10.523438 11.328125 -9.984375 C 11.472656 -9.453125 11.601562 -8.929688 11.71875 -8.421875 C 11.84375 -7.910156 11.941406 -7.46875 12.015625 -7.09375 C 12.097656 -6.726562 12.140625 -6.515625 12.140625 -6.453125 L 11.78125 -11.1875 Z M 11.78125 -23.453125 "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#000000",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(342.309069, 244.572796)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 14.265625 -23.453125 L 14.265625 -20.25 L 9.296875 -20.25 L 9.296875 0 L 5.625 0 L 5.625 -20.25 L 0.65625 -20.25 L 0.65625 -23.453125 Z M 14.265625 -23.453125 "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#000000",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(18.018661, 278.350038)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 8.5 -20.453125 L 8.5 -16.921875 L 5.03125 -16.921875 L 5.03125 -20.453125 Z M 16.953125 -3.046875 C 17.078125 -3.046875 17.140625 -2.976562 17.140625 -2.84375 L 17.140625 -0.15625 C 17.140625 -0.0507812 17.078125 0 16.953125 0 L 13.875 0 L 13.875 0.203125 C 13.875 2.179688 13.300781 3.738281 12.15625 4.875 C 11.007812 6.007812 9.421875 6.578125 7.390625 6.578125 C 5.390625 6.578125 3.820312 6.007812 2.6875 4.875 C 1.550781 3.738281 0.984375 2.179688 0.984375 0.203125 L 0.984375 -10.921875 L 4.453125 -10.921875 L 4.453125 0.234375 C 4.453125 1.410156 4.691406 2.253906 5.171875 2.765625 C 5.648438 3.273438 6.390625 3.53125 7.390625 3.53125 C 8.421875 3.53125 9.179688 3.269531 9.671875 2.75 C 10.160156 2.226562 10.40625 1.390625 10.40625 0.234375 L 10.40625 -15.9375 L 13.875 -15.9375 L 13.875 -3.046875 Z M 16.953125 -3.046875 "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#000000",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(34.800559, 278.350038)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0 0 C -0.101562 0 -0.15625 -0.0507812 -0.15625 -0.15625 L -0.15625 -2.84375 C -0.15625 -2.976562 -0.101562 -3.046875 0 -3.046875 L 6.90625 -3.046875 C 7.007812 -3.046875 7.0625 -2.976562 7.0625 -2.84375 L 7.0625 -0.15625 C 7.0625 -0.0507812 7.007812 0 6.90625 0 Z M 0 0 "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#000000",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(41.703052, 278.350038)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0 0 C -0.101562 0 -0.15625 -0.0507812 -0.15625 -0.15625 L -0.15625 -2.84375 C -0.15625 -2.976562 -0.101562 -3.046875 0 -3.046875 L 6.90625 -3.046875 C 7.007812 -3.046875 7.0625 -2.976562 7.0625 -2.84375 L 7.0625 -0.15625 C 7.0625 -0.0507812 7.007812 0 6.90625 0 Z M 0 0 "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#000000",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(48.605545, 278.350038)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0 0 C -0.101562 0 -0.15625 -0.0507812 -0.15625 -0.15625 L -0.15625 -2.84375 C -0.15625 -2.976562 -0.101562 -3.046875 0 -3.046875 L 6.90625 -3.046875 C 7.007812 -3.046875 7.0625 -2.976562 7.0625 -2.84375 L 7.0625 -0.15625 C 7.0625 -0.0507812 7.007812 0 6.90625 0 Z M 0 0 "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#000000",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(55.508039, 278.350038)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0 0 C -0.101562 0 -0.15625 -0.0507812 -0.15625 -0.15625 L -0.15625 -2.84375 C -0.15625 -2.976562 -0.101562 -3.046875 0 -3.046875 L 6.90625 -3.046875 C 7.007812 -3.046875 7.0625 -2.976562 7.0625 -2.84375 L 7.0625 -0.15625 C 7.0625 -0.0507812 7.007812 0 6.90625 0 Z M 0 0 "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#000000",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(62.410532, 278.350038)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0 0 C -0.101562 0 -0.15625 -0.0507812 -0.15625 -0.15625 L -0.15625 -2.84375 C -0.15625 -2.976562 -0.101562 -3.046875 0 -3.046875 L 6.90625 -3.046875 C 7.007812 -3.046875 7.0625 -2.976562 7.0625 -2.84375 L 7.0625 -0.15625 C 7.0625 -0.0507812 7.007812 0 6.90625 0 Z M 0 0 "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#000000",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(69.313025, 278.350038)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0 0 C -0.101562 0 -0.15625 -0.0507812 -0.15625 -0.15625 L -0.15625 -2.84375 C -0.15625 -2.976562 -0.101562 -3.046875 0 -3.046875 L 6.90625 -3.046875 C 7.007812 -3.046875 7.0625 -2.976562 7.0625 -2.84375 L 7.0625 -0.15625 C 7.0625 -0.0507812 7.007812 0 6.90625 0 Z M 0 0 "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#000000",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(76.215518, 278.350038)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0 0 C -0.101562 0 -0.15625 -0.0507812 -0.15625 -0.15625 L -0.15625 -2.84375 C -0.15625 -2.976562 -0.101562 -3.046875 0 -3.046875 L 6.90625 -3.046875 C 7.007812 -3.046875 7.0625 -2.976562 7.0625 -2.84375 L 7.0625 -0.15625 C 7.0625 -0.0507812 7.007812 0 6.90625 0 Z M 0 0 "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#000000",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(83.118011, 278.350038)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0 0 C -0.101562 0 -0.15625 -0.0507812 -0.15625 -0.15625 L -0.15625 -2.84375 C -0.15625 -2.976562 -0.101562 -3.046875 0 -3.046875 L 6.90625 -3.046875 C 7.007812 -3.046875 7.0625 -2.976562 7.0625 -2.84375 L 7.0625 -0.15625 C 7.0625 -0.0507812 7.007812 0 6.90625 0 Z M 0 0 "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#000000",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(90.020504, 278.350038)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0 0 C -0.101562 0 -0.15625 -0.0507812 -0.15625 -0.15625 L -0.15625 -2.84375 C -0.15625 -2.976562 -0.101562 -3.046875 0 -3.046875 L 6.90625 -3.046875 C 7.007812 -3.046875 7.0625 -2.976562 7.0625 -2.84375 L 7.0625 -0.15625 C 7.0625 -0.0507812 7.007812 0 6.90625 0 Z M 0 0 "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#000000",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(96.922997, 278.350038)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0 0 C -0.101562 0 -0.15625 -0.0507812 -0.15625 -0.15625 L -0.15625 -2.84375 C -0.15625 -2.976562 -0.101562 -3.046875 0 -3.046875 L 6.90625 -3.046875 C 7.007812 -3.046875 7.0625 -2.976562 7.0625 -2.84375 L 7.0625 -0.15625 C 7.0625 -0.0507812 7.007812 0 6.90625 0 Z M 0 0 "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#000000",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(103.82549, 278.350038)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0 0 C -0.101562 0 -0.15625 -0.0507812 -0.15625 -0.15625 L -0.15625 -2.84375 C -0.15625 -2.976562 -0.101562 -3.046875 0 -3.046875 L 6.90625 -3.046875 C 7.007812 -3.046875 7.0625 -2.976562 7.0625 -2.84375 L 7.0625 -0.15625 C 7.0625 -0.0507812 7.007812 0 6.90625 0 Z M 0 0 "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#000000",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(110.727983, 278.350038)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0 0 C -0.101562 0 -0.15625 -0.0507812 -0.15625 -0.15625 L -0.15625 -2.84375 C -0.15625 -2.976562 -0.101562 -3.046875 0 -3.046875 L 6.90625 -3.046875 C 7.007812 -3.046875 7.0625 -2.976562 7.0625 -2.84375 L 7.0625 -0.15625 C 7.0625 -0.0507812 7.007812 0 6.90625 0 Z M 0 0 "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#000000",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(117.630476, 278.350038)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0 0 C -0.101562 0 -0.15625 -0.0507812 -0.15625 -0.15625 L -0.15625 -2.84375 C -0.15625 -2.976562 -0.101562 -3.046875 0 -3.046875 L 6.90625 -3.046875 C 7.007812 -3.046875 7.0625 -2.976562 7.0625 -2.84375 L 7.0625 -0.15625 C 7.0625 -0.0507812 7.007812 0 6.90625 0 Z M 0 0 "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#000000",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(124.532969, 278.350038)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0 0 C -0.101562 0 -0.15625 -0.0507812 -0.15625 -0.15625 L -0.15625 -2.84375 C -0.15625 -2.976562 -0.101562 -3.046875 0 -3.046875 L 6.90625 -3.046875 C 7.007812 -3.046875 7.0625 -2.976562 7.0625 -2.84375 L 7.0625 -0.15625 C 7.0625 -0.0507812 7.007812 0 6.90625 0 Z M 0 0 "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#000000",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(131.435463, 278.350038)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0 0 C -0.101562 0 -0.15625 -0.0507812 -0.15625 -0.15625 L -0.15625 -2.84375 C -0.15625 -2.976562 -0.101562 -3.046875 0 -3.046875 L 6.90625 -3.046875 C 7.007812 -3.046875 7.0625 -2.976562 7.0625 -2.84375 L 7.0625 -0.15625 C 7.0625 -0.0507812 7.007812 0 6.90625 0 Z M 0 0 "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#000000",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(138.337956, 278.350038)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0 0 C -0.101562 0 -0.15625 -0.0507812 -0.15625 -0.15625 L -0.15625 -2.84375 C -0.15625 -2.976562 -0.101562 -3.046875 0 -3.046875 L 6.90625 -3.046875 C 7.007812 -3.046875 7.0625 -2.976562 7.0625 -2.84375 L 7.0625 -0.15625 C 7.0625 -0.0507812 7.007812 0 6.90625 0 Z M 0 0 "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#000000",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(145.240449, 278.350038)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 8.375 -11.390625 C 9.75 -10.429688 10.703125 -9.457031 11.234375 -8.46875 C 11.773438 -7.488281 12.03125 -6.507812 12 -5.53125 C 11.976562 -3.675781 11.441406 -2.289062 10.390625 -1.375 C 9.347656 -0.457031 7.925781 0 6.125 0 L -0.15625 0 C -0.289062 0 -0.359375 -0.0507812 -0.359375 -0.15625 L -0.359375 -2.84375 C -0.359375 -2.976562 -0.289062 -3.046875 -0.15625 -3.046875 L 6.125 -3.046875 C 6.945312 -3.046875 7.554688 -3.234375 7.953125 -3.609375 C 8.347656 -3.992188 8.546875 -4.675781 8.546875 -5.65625 C 8.546875 -6.132812 8.398438 -6.632812 8.109375 -7.15625 C 7.828125 -7.6875 7.257812 -8.253906 6.40625 -8.859375 C 5.925781 -9.191406 5.363281 -9.585938 4.71875 -10.046875 C 4.082031 -10.503906 3.457031 -10.941406 2.84375 -11.359375 C 2.238281 -11.785156 1.75 -12.132812 1.375 -12.40625 C 1 -12.6875 0.847656 -12.804688 0.921875 -12.765625 L 0.921875 -15.34375 L 11.875 -23.625 L 11.875 -19.796875 L 4.359375 -14.234375 C 4.984375 -13.816406 5.671875 -13.332031 6.421875 -12.78125 C 7.179688 -12.238281 7.832031 -11.773438 8.375 -11.390625 Z M 8.375 -11.390625 "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#000000",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(157.965444, 278.350038)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 10.203125 -3.046875 C 10.335938 -3.046875 10.40625 -2.976562 10.40625 -2.84375 L 10.40625 -0.15625 C 10.40625 -0.0507812 10.335938 0 10.203125 0 L 6.765625 0 L 6.765625 1.046875 C 6.765625 2.765625 6.257812 4.113281 5.25 5.09375 C 4.238281 6.082031 2.878906 6.578125 1.171875 6.578125 C 0.566406 6.578125 0.0078125 6.535156 -0.5 6.453125 C -1.019531 6.378906 -1.410156 6.3125 -1.671875 6.25 L -0.984375 3.234375 C -0.722656 3.328125 -0.441406 3.398438 -0.140625 3.453125 C 0.148438 3.503906 0.597656 3.53125 1.203125 3.53125 C 1.972656 3.53125 2.515625 3.351562 2.828125 3 C 3.140625 2.65625 3.296875 2.023438 3.296875 1.109375 L 3.296875 -15.9375 L 6.765625 -15.9375 L 6.765625 -3.046875 Z M 10.203125 -3.046875 "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#000000",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(168.008418, 278.350038)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0 0 C -0.101562 0 -0.15625 -0.0507812 -0.15625 -0.15625 L -0.15625 -2.84375 C -0.15625 -2.976562 -0.101562 -3.046875 0 -3.046875 L 6.90625 -3.046875 C 7.007812 -3.046875 7.0625 -2.976562 7.0625 -2.84375 L 7.0625 -0.15625 C 7.0625 -0.0507812 7.007812 0 6.90625 0 Z M 0 0 "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#000000",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(174.910911, 278.350038)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M -0.15625 0 C -0.289062 0 -0.359375 -0.0507812 -0.359375 -0.15625 L -0.359375 -2.84375 C -0.359375 -2.976562 -0.289062 -3.046875 -0.15625 -3.046875 L 2.9375 -3.046875 L 2.9375 -23.625 L 6.40625 -23.625 L 6.40625 0 Z M -0.15625 0 "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#000000",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(183.939763, 278.350038)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 2.21875 0 L 2.21875 -23.625 L 5.6875 -23.625 L 5.6875 0 Z M 2.21875 0 "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#000000",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(192.085367, 278.350038)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: ""
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#000000",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(199.020571, 278.350038)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 6.078125 -22.046875 L 6.078125 -18.515625 L 2.875 -18.515625 L 2.875 -22.046875 Z M 10.28125 -22.046875 L 10.28125 -18.515625 L 7.0625 -18.515625 L 7.0625 -22.046875 Z M 15.34375 -3.046875 C 15.457031 -3.046875 15.515625 -2.976562 15.515625 -2.84375 L 15.515625 -0.15625 C 15.515625 -0.0507812 15.457031 0 15.34375 0 L 15.109375 0 C 14.191406 0 13.363281 -0.128906 12.625 -0.390625 C 11.882812 -0.648438 11.242188 -0.988281 10.703125 -1.40625 C 10.128906 -1.03125 9.425781 -0.703125 8.59375 -0.421875 C 7.769531 -0.140625 6.828125 0 5.765625 0 C 4.234375 0 3.050781 -0.414062 2.21875 -1.25 C 1.394531 -2.09375 0.984375 -3.3125 0.984375 -4.90625 L 0.984375 -11.28125 C 0.984375 -12.332031 1.226562 -13.222656 1.71875 -13.953125 C 2.207031 -14.679688 2.867188 -15.238281 3.703125 -15.625 C 4.546875 -16.007812 5.472656 -16.203125 6.484375 -16.203125 C 7.328125 -16.203125 8.289062 -16.113281 9.375 -15.9375 C 10.457031 -15.757812 11.378906 -15.550781 12.140625 -15.3125 L 12.140625 -5.46875 C 12.140625 -4.53125 12.382812 -3.890625 12.875 -3.546875 C 13.363281 -3.210938 14.109375 -3.046875 15.109375 -3.046875 Z M 6.546875 -3.046875 C 7.046875 -3.023438 7.503906 -3.078125 7.921875 -3.203125 C 8.335938 -3.335938 8.695312 -3.492188 9 -3.671875 C 8.90625 -3.972656 8.828125 -4.273438 8.765625 -4.578125 C 8.703125 -4.878906 8.671875 -5.175781 8.671875 -5.46875 L 8.671875 -12.953125 C 8.253906 -13.046875 7.875 -13.101562 7.53125 -13.125 C 7.195312 -13.144531 6.867188 -13.15625 6.546875 -13.15625 C 5.804688 -13.15625 5.269531 -13.007812 4.9375 -12.71875 C 4.613281 -12.4375 4.453125 -11.847656 4.453125 -10.953125 L 4.453125 -5.234375 C 4.453125 -4.492188 4.628906 -3.945312 4.984375 -3.59375 C 5.347656 -3.25 5.867188 -3.066406 6.546875 -3.046875 Z M 6.546875 -3.046875 "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#000000",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(214.166816, 278.350038)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0 0 C -0.101562 0 -0.15625 -0.0507812 -0.15625 -0.15625 L -0.15625 -2.84375 C -0.15625 -2.976562 -0.101562 -3.046875 0 -3.046875 L 6.90625 -3.046875 C 7.007812 -3.046875 7.0625 -2.976562 7.0625 -2.84375 L 7.0625 -0.15625 C 7.0625 -0.0507812 7.007812 0 6.90625 0 Z M 0 0 "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#000000",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(221.06931, 278.350038)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0 0 C -0.101562 0 -0.15625 -0.0507812 -0.15625 -0.15625 L -0.15625 -2.84375 C -0.15625 -2.976562 -0.101562 -3.046875 0 -3.046875 L 6.90625 -3.046875 C 7.007812 -3.046875 7.0625 -2.976562 7.0625 -2.84375 L 7.0625 -0.15625 C 7.0625 -0.0507812 7.007812 0 6.90625 0 Z M 0 0 "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#000000",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(227.971803, 278.350038)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0 0 C -0.101562 0 -0.15625 -0.0507812 -0.15625 -0.15625 L -0.15625 -2.84375 C -0.15625 -2.976562 -0.101562 -3.046875 0 -3.046875 L 6.90625 -3.046875 C 7.007812 -3.046875 7.0625 -2.976562 7.0625 -2.84375 L 7.0625 -0.15625 C 7.0625 -0.0507812 7.007812 0 6.90625 0 Z M 0 0 "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#000000",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(234.874296, 278.350038)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0 0 C -0.101562 0 -0.15625 -0.0507812 -0.15625 -0.15625 L -0.15625 -2.84375 C -0.15625 -2.976562 -0.101562 -3.046875 0 -3.046875 L 6.90625 -3.046875 C 7.007812 -3.046875 7.0625 -2.976562 7.0625 -2.84375 L 7.0625 -0.15625 C 7.0625 -0.0507812 7.007812 0 6.90625 0 Z M 0 0 "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#000000",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(241.776789, 278.350038)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0 0 C -0.101562 0 -0.15625 -0.0507812 -0.15625 -0.15625 L -0.15625 -2.84375 C -0.15625 -2.976562 -0.101562 -3.046875 0 -3.046875 L 6.90625 -3.046875 C 7.007812 -3.046875 7.0625 -2.976562 7.0625 -2.84375 L 7.0625 -0.15625 C 7.0625 -0.0507812 7.007812 0 6.90625 0 Z M 0 0 "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#000000",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(248.679282, 278.350038)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0 0 C -0.101562 0 -0.15625 -0.0507812 -0.15625 -0.15625 L -0.15625 -2.84375 C -0.15625 -2.976562 -0.101562 -3.046875 0 -3.046875 L 6.90625 -3.046875 C 7.007812 -3.046875 7.0625 -2.976562 7.0625 -2.84375 L 7.0625 -0.15625 C 7.0625 -0.0507812 7.007812 0 6.90625 0 Z M 0 0 "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#000000",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(255.581775, 278.350038)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0 0 C -0.101562 0 -0.15625 -0.0507812 -0.15625 -0.15625 L -0.15625 -2.84375 C -0.15625 -2.976562 -0.101562 -3.046875 0 -3.046875 L 6.90625 -3.046875 C 7.007812 -3.046875 7.0625 -2.976562 7.0625 -2.84375 L 7.0625 -0.15625 C 7.0625 -0.0507812 7.007812 0 6.90625 0 Z M 0 0 "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#000000",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(262.484268, 278.350038)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0 0 C -0.101562 0 -0.15625 -0.0507812 -0.15625 -0.15625 L -0.15625 -2.84375 C -0.15625 -2.976562 -0.101562 -3.046875 0 -3.046875 L 6.90625 -3.046875 C 7.007812 -3.046875 7.0625 -2.976562 7.0625 -2.84375 L 7.0625 -0.15625 C 7.0625 -0.0507812 7.007812 0 6.90625 0 Z M 0 0 "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#000000",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(269.386761, 278.350038)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0 0 C -0.101562 0 -0.15625 -0.0507812 -0.15625 -0.15625 L -0.15625 -2.84375 C -0.15625 -2.976562 -0.101562 -3.046875 0 -3.046875 L 6.90625 -3.046875 C 7.007812 -3.046875 7.0625 -2.976562 7.0625 -2.84375 L 7.0625 -0.15625 C 7.0625 -0.0507812 7.007812 0 6.90625 0 Z M 0 0 "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#000000",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(276.289254, 278.350038)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0 0 C -0.101562 0 -0.15625 -0.0507812 -0.15625 -0.15625 L -0.15625 -2.84375 C -0.15625 -2.976562 -0.101562 -3.046875 0 -3.046875 L 6.90625 -3.046875 C 7.007812 -3.046875 7.0625 -2.976562 7.0625 -2.84375 L 7.0625 -0.15625 C 7.0625 -0.0507812 7.007812 0 6.90625 0 Z M 0 0 "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#000000",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(283.191747, 278.350038)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0 0 C -0.101562 0 -0.15625 -0.0507812 -0.15625 -0.15625 L -0.15625 -2.84375 C -0.15625 -2.976562 -0.101562 -3.046875 0 -3.046875 L 6.90625 -3.046875 C 7.007812 -3.046875 7.0625 -2.976562 7.0625 -2.84375 L 7.0625 -0.15625 C 7.0625 -0.0507812 7.007812 0 6.90625 0 Z M 0 0 "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#000000",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(290.09424, 278.350038)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0 0 C -0.101562 0 -0.15625 -0.0507812 -0.15625 -0.15625 L -0.15625 -2.84375 C -0.15625 -2.976562 -0.101562 -3.046875 0 -3.046875 L 6.90625 -3.046875 C 7.007812 -3.046875 7.0625 -2.976562 7.0625 -2.84375 L 7.0625 -0.15625 C 7.0625 -0.0507812 7.007812 0 6.90625 0 Z M 0 0 "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#000000",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(296.996734, 278.350038)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 8.640625 -16.203125 C 10.378906 -16.203125 11.75 -15.710938 12.75 -14.734375 C 13.757812 -13.765625 14.265625 -12.429688 14.265625 -10.734375 L 14.265625 -5.171875 C 14.265625 -3.472656 13.757812 -2.140625 12.75 -1.171875 C 11.75 -0.210938 10.378906 0.265625 8.640625 0.265625 C 7.703125 0.265625 6.890625 0.117188 6.203125 -0.171875 C 5.515625 -0.472656 4.953125 -0.894531 4.515625 -1.4375 C 3.273438 -0.476562 1.769531 0 0 0 L -0.15625 0 C -0.289062 0 -0.359375 -0.0507812 -0.359375 -0.15625 L -0.359375 -2.84375 C -0.359375 -2.976562 -0.289062 -3.046875 -0.15625 -3.046875 L 0 -3.046875 C 1 -3.046875 1.75 -3.210938 2.25 -3.546875 C 2.757812 -3.890625 3.015625 -4.539062 3.015625 -5.5 L 3.015625 -15.34375 C 3.710938 -15.5625 4.578125 -15.757812 5.609375 -15.9375 C 6.648438 -16.113281 7.660156 -16.203125 8.640625 -16.203125 Z M 10.796875 -5.203125 L 10.796875 -10.703125 C 10.796875 -11.597656 10.625 -12.226562 10.28125 -12.59375 C 9.945312 -12.96875 9.398438 -13.15625 8.640625 -13.15625 C 7.941406 -13.15625 7.222656 -13.078125 6.484375 -12.921875 L 6.484375 -5.203125 C 6.484375 -4.304688 6.648438 -3.671875 6.984375 -3.296875 C 7.328125 -2.929688 7.878906 -2.75 8.640625 -2.75 C 9.398438 -2.75 9.945312 -2.929688 10.28125 -3.296875 C 10.625 -3.671875 10.796875 -4.304688 10.796875 -5.203125 Z M 10.796875 -5.203125 "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#000000",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(313.222522, 278.350038)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 14.953125 -3.046875 C 15.054688 -3.046875 15.109375 -2.976562 15.109375 -2.84375 L 15.109375 -0.15625 C 15.109375 -0.0507812 15.054688 0 14.953125 0 L 0.328125 0 L 0.328125 -3.046875 L 7.984375 -3.046875 L 7.984375 -10.46875 C 7.984375 -11.382812 7.816406 -12.015625 7.484375 -12.359375 C 7.160156 -12.710938 6.640625 -12.890625 5.921875 -12.890625 L 3.5625 -12.890625 L 3.5625 -15.9375 L 5.921875 -15.9375 C 7.597656 -15.9375 8.9375 -15.460938 9.9375 -14.515625 C 10.945312 -13.566406 11.453125 -12.226562 11.453125 -10.5 L 11.453125 -3.046875 Z M 14.953125 -3.046875 "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#000000",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(327.976209, 278.350038)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0 0 C -0.101562 0 -0.15625 -0.0507812 -0.15625 -0.15625 L -0.15625 -2.84375 C -0.15625 -2.976562 -0.101562 -3.046875 0 -3.046875 L 6.90625 -3.046875 C 7.007812 -3.046875 7.0625 -2.976562 7.0625 -2.84375 L 7.0625 -0.15625 C 7.0625 -0.0507812 7.007812 0 6.90625 0 Z M 0 0 "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#000000",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(334.878669, 278.350038)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0 0 C -0.101562 0 -0.15625 -0.0507812 -0.15625 -0.15625 L -0.15625 -2.84375 C -0.15625 -2.976562 -0.101562 -3.046875 0 -3.046875 L 6.90625 -3.046875 C 7.007812 -3.046875 7.0625 -2.976562 7.0625 -2.84375 L 7.0625 -0.15625 C 7.0625 -0.0507812 7.007812 0 6.90625 0 Z M 0 0 "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#000000",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(341.781195, 278.350038)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 5.71875 -18.546875 L 5.71875 -22.078125 L 9.1875 -22.078125 L 9.1875 -18.546875 Z M -0.15625 0 C -0.289062 0 -0.359375 -0.0507812 -0.359375 -0.15625 L -0.359375 -2.84375 C -0.359375 -2.976562 -0.289062 -3.046875 -0.15625 -3.046875 L 9.546875 -3.046875 L 9.546875 -10.734375 C 9.546875 -11.648438 9.382812 -12.28125 9.0625 -12.625 C 8.738281 -12.976562 8.203125 -13.15625 7.453125 -13.15625 C 7.148438 -13.15625 6.820312 -13.144531 6.46875 -13.125 C 6.125 -13.101562 5.742188 -13.046875 5.328125 -12.953125 L 5.328125 -8.46875 L 1.859375 -8.46875 L 1.859375 -15.3125 C 2.648438 -15.507812 3.535156 -15.707031 4.515625 -15.90625 C 5.492188 -16.101562 6.472656 -16.203125 7.453125 -16.203125 C 9.179688 -16.203125 10.539062 -15.722656 11.53125 -14.765625 C 12.519531 -13.816406 13.015625 -12.492188 13.015625 -10.796875 L 13.015625 0 Z M -0.15625 0 "
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "#000000",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M -0.00256285 0.497792 L 118.117246 0.497792 ",
    transform: "matrix(0.749305,0,0,0.749305,268.665983,301.150439)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#000000",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(113.459327, 303.868379)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 4.46875 -9 L 5.890625 -9 L 3.65625 0 L 2.484375 0 L 0.25 -9 L 1.65625 -9 L 2.8125 -3.921875 L 3.09375 -2.25 L 3.34375 -3.921875 Z M 4.46875 -9 "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#000000",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(119.608983, 303.868379)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0.875 0.015625 L 0.875 -9 L 2.28125 -9 L 2.28125 0.015625 Z M 0.875 0.015625 "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#000000",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(122.759108, 303.868379)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 2.28125 -1.234375 L 5.359375 -1.234375 L 5.359375 0 L 0.875 0 L 0.875 -9 L 2.28125 -9 Z M 2.28125 -1.234375 "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#000000",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(128.168285, 303.868379)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 2.28125 -1.234375 L 5.359375 -1.234375 L 5.359375 0 L 0.875 0 L 0.875 -9 L 2.28125 -9 Z M 2.28125 -1.234375 "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#000000",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(133.577462, 303.868379)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 5.125 -7.765625 L 2.265625 -7.765625 L 2.265625 -5.265625 L 4.890625 -5.265625 L 4.890625 -4.046875 L 2.265625 -4.046875 L 2.265625 -1.234375 L 5.125 -1.234375 L 5.125 0 L 0.875 0 L 0.875 -9 L 5.125 -9 Z M 5.125 -7.765625 "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#000000",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(139.124703, 303.868379)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: ""
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#000000",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(141.785365, 303.868379)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 3.21875 -9 C 3.9375 -9 4.507812 -8.796875 4.9375 -8.390625 C 5.363281 -7.992188 5.578125 -7.457031 5.578125 -6.78125 L 5.578125 -2.21875 C 5.578125 -1.550781 5.363281 -1.015625 4.9375 -0.609375 C 4.507812 -0.203125 3.9375 0 3.21875 0 L 0.875 0 L 0.875 -9 Z M 4.171875 -2.234375 L 4.171875 -6.765625 C 4.171875 -7.109375 4.09375 -7.359375 3.9375 -7.515625 C 3.789062 -7.679688 3.550781 -7.765625 3.21875 -7.765625 L 2.265625 -7.765625 L 2.265625 -1.234375 L 3.21875 -1.234375 C 3.550781 -1.234375 3.789062 -1.3125 3.9375 -1.46875 C 4.09375 -1.632812 4.171875 -1.890625 4.171875 -2.234375 Z M 4.171875 -2.234375 "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#000000",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(148.035417, 303.868379)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 5.125 -7.765625 L 2.265625 -7.765625 L 2.265625 -5.265625 L 4.890625 -5.265625 L 4.890625 -4.046875 L 2.265625 -4.046875 L 2.265625 -1.234375 L 5.125 -1.234375 L 5.125 0 L 0.875 0 L 0.875 -9 L 5.125 -9 Z M 5.125 -7.765625 "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#000000",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(153.582658, 303.868379)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: ""
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#000000",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(156.24332, 303.868379)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 5.46875 -9 L 5.46875 -7.765625 L 3.5625 -7.765625 L 3.5625 0 L 2.15625 0 L 2.15625 -7.765625 L 0.25 -7.765625 L 0.25 -9 Z M 5.46875 -9 "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#000000",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(161.953711, 303.868379)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 4.65625 0 L 4.21875 -1.875 L 2.03125 -1.875 L 1.59375 0 L 0.1875 0 L 2.53125 -9 L 3.71875 -9 L 6.078125 0 Z M 2.328125 -3.125 L 3.921875 -3.125 L 3.328125 -5.65625 C 3.285156 -5.8125 3.242188 -5.976562 3.203125 -6.15625 C 3.171875 -6.34375 3.140625 -6.53125 3.109375 -6.71875 C 3.085938 -6.539062 3.054688 -6.359375 3.015625 -6.171875 C 2.984375 -5.992188 2.945312 -5.832031 2.90625 -5.6875 Z M 2.328125 -3.125 "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#000000",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(168.216319, 303.868379)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 4.515625 -9 L 5.890625 -9 L 5.890625 0 L 4.53125 0 L 2.59375 -4.8125 C 2.507812 -5.007812 2.429688 -5.25 2.359375 -5.53125 C 2.285156 -5.8125 2.222656 -6.078125 2.171875 -6.328125 C 2.117188 -6.578125 2.082031 -6.738281 2.0625 -6.8125 L 2.21875 -5 L 2.21875 0 L 0.875 0 L 0.875 -9 L 2.421875 -9 L 4.171875 -4.359375 C 4.234375 -4.210938 4.289062 -4.035156 4.34375 -3.828125 C 4.394531 -3.628906 4.441406 -3.429688 4.484375 -3.234375 C 4.535156 -3.035156 4.578125 -2.863281 4.609375 -2.71875 C 4.640625 -2.582031 4.65625 -2.5 4.65625 -2.46875 L 4.515625 -4.296875 Z M 4.515625 -9 "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#000000",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(174.96839, 303.868379)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 3.078125 -5.1875 L 5.625 -5.1875 L 5.625 -0.765625 C 5.375 -0.503906 5.035156 -0.289062 4.609375 -0.125 C 4.191406 0.0390625 3.710938 0.125 3.171875 0.125 C 2.679688 0.125 2.25 0.0351562 1.875 -0.140625 C 1.5 -0.328125 1.203125 -0.585938 0.984375 -0.921875 C 0.773438 -1.265625 0.671875 -1.65625 0.671875 -2.09375 L 0.671875 -6.890625 C 0.671875 -7.328125 0.773438 -7.710938 0.984375 -8.046875 C 1.191406 -8.390625 1.476562 -8.65625 1.84375 -8.84375 C 2.21875 -9.03125 2.648438 -9.117188 3.140625 -9.109375 C 3.628906 -9.097656 4.054688 -9.023438 4.421875 -8.890625 C 4.785156 -8.753906 5.097656 -8.601562 5.359375 -8.4375 L 5.359375 -6.46875 L 4.046875 -6.46875 L 4.046875 -7.703125 C 3.910156 -7.753906 3.757812 -7.796875 3.59375 -7.828125 C 3.425781 -7.859375 3.269531 -7.875 3.125 -7.875 C 2.425781 -7.875 2.078125 -7.539062 2.078125 -6.875 L 2.078125 -2.109375 C 2.078125 -1.441406 2.441406 -1.109375 3.171875 -1.109375 C 3.492188 -1.109375 3.742188 -1.148438 3.921875 -1.234375 C 4.097656 -1.316406 4.195312 -1.363281 4.21875 -1.375 L 4.21875 -3.953125 L 3.078125 -3.953125 Z M 3.078125 -5.1875 "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#000000",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(181.331394, 303.868379)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 5.125 -7.765625 L 2.265625 -7.765625 L 2.265625 -5.265625 L 4.890625 -5.265625 L 4.890625 -4.046875 L 2.265625 -4.046875 L 2.265625 -1.234375 L 5.125 -1.234375 L 5.125 0 L 0.875 0 L 0.875 -9 L 5.125 -9 Z M 5.125 -7.765625 "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#000000",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(186.878635, 303.868379)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 4.5625 0 L 2.90625 -3.5625 C 2.8125 -3.570312 2.710938 -3.582031 2.609375 -3.59375 C 2.503906 -3.613281 2.394531 -3.632812 2.28125 -3.65625 L 2.28125 0 L 0.875 0 L 0.875 -9 L 3.15625 -9 C 3.875 -9 4.445312 -8.796875 4.875 -8.390625 C 5.300781 -7.984375 5.515625 -7.445312 5.515625 -6.78125 L 5.515625 -5.796875 C 5.515625 -5.335938 5.410156 -4.929688 5.203125 -4.578125 C 5.003906 -4.234375 4.71875 -3.972656 4.34375 -3.796875 L 6.125 0 Z M 2.28125 -7.765625 L 2.28125 -4.921875 C 2.601562 -4.847656 2.875 -4.8125 3.09375 -4.8125 C 3.445312 -4.8125 3.703125 -4.894531 3.859375 -5.0625 C 4.023438 -5.226562 4.109375 -5.484375 4.109375 -5.828125 L 4.109375 -6.765625 C 4.109375 -7.109375 4.03125 -7.359375 3.875 -7.515625 C 3.726562 -7.679688 3.488281 -7.765625 3.15625 -7.765625 Z M 2.28125 -7.765625 "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#000000",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(202.869469, 303.646213)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 2.359375 -8.578125 L 2.359375 -7.203125 L 1.125 -7.203125 L 1.125 -8.578125 Z M 4 -8.578125 L 4 -7.203125 L 2.75 -7.203125 L 2.75 -8.578125 Z M 5.96875 -1.1875 C 6.007812 -1.1875 6.03125 -1.160156 6.03125 -1.109375 L 6.03125 -0.0625 C 6.03125 -0.0195312 6.007812 0 5.96875 0 L 5.875 0 C 5.519531 0 5.195312 -0.0507812 4.90625 -0.15625 C 4.625 -0.257812 4.375 -0.390625 4.15625 -0.546875 C 3.9375 -0.398438 3.664062 -0.269531 3.34375 -0.15625 C 3.019531 -0.0507812 2.648438 0 2.234375 0 C 1.640625 0 1.179688 -0.160156 0.859375 -0.484375 C 0.535156 -0.816406 0.375 -1.289062 0.375 -1.90625 L 0.375 -4.390625 C 0.375 -4.796875 0.46875 -5.140625 0.65625 -5.421875 C 0.851562 -5.703125 1.113281 -5.914062 1.4375 -6.0625 C 1.769531 -6.21875 2.128906 -6.296875 2.515625 -6.296875 C 2.847656 -6.296875 3.222656 -6.257812 3.640625 -6.1875 C 4.066406 -6.125 4.425781 -6.046875 4.71875 -5.953125 L 4.71875 -2.125 C 4.71875 -1.757812 4.8125 -1.507812 5 -1.375 C 5.195312 -1.25 5.488281 -1.1875 5.875 -1.1875 Z M 2.546875 -1.1875 C 2.742188 -1.175781 2.921875 -1.195312 3.078125 -1.25 C 3.234375 -1.300781 3.375 -1.359375 3.5 -1.421875 C 3.46875 -1.546875 3.4375 -1.664062 3.40625 -1.78125 C 3.382812 -1.894531 3.375 -2.007812 3.375 -2.125 L 3.375 -5.03125 C 3.207031 -5.070312 3.054688 -5.09375 2.921875 -5.09375 C 2.796875 -5.101562 2.671875 -5.109375 2.546875 -5.109375 C 2.253906 -5.109375 2.046875 -5.050781 1.921875 -4.9375 C 1.796875 -4.832031 1.734375 -4.609375 1.734375 -4.265625 L 1.734375 -2.03125 C 1.734375 -1.75 1.800781 -1.539062 1.9375 -1.40625 C 2.082031 -1.269531 2.285156 -1.195312 2.546875 -1.1875 Z M 2.546875 -1.1875 "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#000000",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(208.760989, 303.646213)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0 0 C -0.0390625 0 -0.0625 -0.0195312 -0.0625 -0.0625 L -0.0625 -1.109375 C -0.0625 -1.160156 -0.0390625 -1.1875 0 -1.1875 L 2.6875 -1.1875 C 2.726562 -1.1875 2.75 -1.160156 2.75 -1.109375 L 2.75 -0.0625 C 2.75 -0.0195312 2.726562 0 2.6875 0 Z M 0 0 "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#000000",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(211.445885, 303.646213)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0 0 C -0.0390625 0 -0.0625 -0.0195312 -0.0625 -0.0625 L -0.0625 -1.109375 C -0.0625 -1.160156 -0.0390625 -1.1875 0 -1.1875 L 2.6875 -1.1875 C 2.726562 -1.1875 2.75 -1.160156 2.75 -1.109375 L 2.75 -0.0625 C 2.75 -0.0195312 2.726562 0 2.6875 0 Z M 0 0 "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#000000",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(214.130781, 303.646213)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0 0 C -0.0390625 0 -0.0625 -0.0195312 -0.0625 -0.0625 L -0.0625 -1.109375 C -0.0625 -1.160156 -0.0390625 -1.1875 0 -1.1875 L 2.6875 -1.1875 C 2.726562 -1.1875 2.75 -1.160156 2.75 -1.109375 L 2.75 -0.0625 C 2.75 -0.0195312 2.726562 0 2.6875 0 Z M 0 0 "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#000000",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(216.815677, 303.646213)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 6.4375 -1.1875 C 6.476562 -1.1875 6.5 -1.160156 6.5 -1.109375 L 6.5 -0.0625 C 6.5 -0.0195312 6.476562 0 6.4375 0 L -0.0625 0 C -0.113281 0 -0.140625 -0.0195312 -0.140625 -0.0625 L -0.140625 -1.109375 C -0.140625 -1.160156 -0.113281 -1.1875 -0.0625 -1.1875 L 3.71875 -1.1875 L 3.71875 -4.171875 C 3.71875 -4.523438 3.648438 -4.769531 3.515625 -4.90625 C 3.390625 -5.039062 3.1875 -5.109375 2.90625 -5.109375 C 2.78125 -5.109375 2.648438 -5.101562 2.515625 -5.09375 C 2.378906 -5.09375 2.234375 -5.070312 2.078125 -5.03125 L 2.078125 -3.296875 L 0.71875 -3.296875 L 0.71875 -5.953125 C 1.03125 -6.023438 1.375 -6.097656 1.75 -6.171875 C 2.132812 -6.253906 2.519531 -6.296875 2.90625 -6.296875 C 3.570312 -6.296875 4.097656 -6.109375 4.484375 -5.734375 C 4.867188 -5.367188 5.0625 -4.859375 5.0625 -4.203125 L 5.0625 -1.1875 Z M 2.21875 2.390625 L 2.21875 1.015625 L 3.5625 1.015625 L 3.5625 2.390625 Z M 2.21875 2.390625 "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#000000",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(223.178006, 303.646213)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 2.515625 -8.578125 L 2.515625 -7.21875 L 1.171875 -7.21875 L 1.171875 -8.578125 Z M 3.765625 -1.1875 C 3.816406 -1.1875 3.84375 -1.160156 3.84375 -1.109375 L 3.84375 -0.0625 C 3.84375 -0.0195312 3.816406 0 3.765625 0 L 3.703125 0 C 3.304688 0 2.953125 -0.0546875 2.640625 -0.171875 C 2.328125 -0.296875 2.066406 -0.457031 1.859375 -0.65625 C 1.640625 -0.457031 1.375 -0.296875 1.0625 -0.171875 C 0.757812 -0.0546875 0.40625 0 0 0 L -0.0625 0 C -0.113281 0 -0.140625 -0.0195312 -0.140625 -0.0625 L -0.140625 -1.109375 C -0.140625 -1.160156 -0.113281 -1.1875 -0.0625 -1.1875 L 0 -1.1875 C 0.382812 -1.1875 0.675781 -1.25 0.875 -1.375 C 1.070312 -1.507812 1.171875 -1.757812 1.171875 -2.125 L 1.171875 -6.1875 L 2.515625 -6.1875 L 2.515625 -2.125 C 2.515625 -1.757812 2.613281 -1.507812 2.8125 -1.375 C 3.007812 -1.25 3.304688 -1.1875 3.703125 -1.1875 Z M 3.765625 -1.1875 "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#000000",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(226.880874, 303.646213)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 4.171875 -6.296875 C 4.835938 -6.296875 5.363281 -6.109375 5.75 -5.734375 C 6.132812 -5.359375 6.328125 -4.847656 6.328125 -4.203125 L 6.328125 0 L -0.109375 0 C -0.148438 0 -0.171875 -0.0195312 -0.171875 -0.0625 L -0.171875 -1.109375 C -0.171875 -1.160156 -0.148438 -1.1875 -0.109375 -1.1875 L 1.1875 -1.1875 L 1.1875 -9.1875 L 2.53125 -9.1875 L 2.53125 -5.921875 C 2.78125 -6.015625 3.050781 -6.097656 3.34375 -6.171875 C 3.632812 -6.253906 3.910156 -6.296875 4.171875 -6.296875 Z M 4.96875 -1.1875 L 4.96875 -4.171875 C 4.96875 -4.515625 4.90625 -4.753906 4.78125 -4.890625 C 4.664062 -5.035156 4.46875 -5.109375 4.1875 -5.109375 C 3.988281 -5.109375 3.742188 -5.082031 3.453125 -5.03125 C 3.160156 -4.976562 2.851562 -4.894531 2.53125 -4.78125 L 2.53125 -1.1875 Z M 4.96875 -1.1875 "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#000000",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(233.968509, 303.646213)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: ""
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#000000",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(236.666139, 303.646213)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 2.359375 -8.578125 L 2.359375 -7.203125 L 1.125 -7.203125 L 1.125 -8.578125 Z M 4 -8.578125 L 4 -7.203125 L 2.75 -7.203125 L 2.75 -8.578125 Z M 5.96875 -1.1875 C 6.007812 -1.1875 6.03125 -1.160156 6.03125 -1.109375 L 6.03125 -0.0625 C 6.03125 -0.0195312 6.007812 0 5.96875 0 L 5.875 0 C 5.519531 0 5.195312 -0.0507812 4.90625 -0.15625 C 4.625 -0.257812 4.375 -0.390625 4.15625 -0.546875 C 3.9375 -0.398438 3.664062 -0.269531 3.34375 -0.15625 C 3.019531 -0.0507812 2.648438 0 2.234375 0 C 1.640625 0 1.179688 -0.160156 0.859375 -0.484375 C 0.535156 -0.816406 0.375 -1.289062 0.375 -1.90625 L 0.375 -4.390625 C 0.375 -4.796875 0.46875 -5.140625 0.65625 -5.421875 C 0.851562 -5.703125 1.113281 -5.914062 1.4375 -6.0625 C 1.769531 -6.21875 2.128906 -6.296875 2.515625 -6.296875 C 2.847656 -6.296875 3.222656 -6.257812 3.640625 -6.1875 C 4.066406 -6.125 4.425781 -6.046875 4.71875 -5.953125 L 4.71875 -2.125 C 4.71875 -1.757812 4.8125 -1.507812 5 -1.375 C 5.195312 -1.25 5.488281 -1.1875 5.875 -1.1875 Z M 2.546875 -1.1875 C 2.742188 -1.175781 2.921875 -1.195312 3.078125 -1.25 C 3.234375 -1.300781 3.375 -1.359375 3.5 -1.421875 C 3.46875 -1.546875 3.4375 -1.664062 3.40625 -1.78125 C 3.382812 -1.894531 3.375 -2.007812 3.375 -2.125 L 3.375 -5.03125 C 3.207031 -5.070312 3.054688 -5.09375 2.921875 -5.09375 C 2.796875 -5.101562 2.671875 -5.109375 2.546875 -5.109375 C 2.253906 -5.109375 2.046875 -5.050781 1.921875 -4.9375 C 1.796875 -4.832031 1.734375 -4.609375 1.734375 -4.265625 L 1.734375 -2.03125 C 1.734375 -1.75 1.800781 -1.539062 1.9375 -1.40625 C 2.082031 -1.269531 2.285156 -1.195312 2.546875 -1.1875 Z M 2.546875 -1.1875 "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#000000",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(242.557659, 303.646213)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 2.515625 -8.578125 L 2.515625 -7.21875 L 1.171875 -7.21875 L 1.171875 -8.578125 Z M 3.765625 -1.1875 C 3.816406 -1.1875 3.84375 -1.160156 3.84375 -1.109375 L 3.84375 -0.0625 C 3.84375 -0.0195312 3.816406 0 3.765625 0 L 3.703125 0 C 3.304688 0 2.953125 -0.0546875 2.640625 -0.171875 C 2.328125 -0.296875 2.066406 -0.457031 1.859375 -0.65625 C 1.640625 -0.457031 1.375 -0.296875 1.0625 -0.171875 C 0.757812 -0.0546875 0.40625 0 0 0 L -0.0625 0 C -0.113281 0 -0.140625 -0.0195312 -0.140625 -0.0625 L -0.140625 -1.109375 C -0.140625 -1.160156 -0.113281 -1.1875 -0.0625 -1.1875 L 0 -1.1875 C 0.382812 -1.1875 0.675781 -1.25 0.875 -1.375 C 1.070312 -1.507812 1.171875 -1.757812 1.171875 -2.125 L 1.171875 -6.1875 L 2.515625 -6.1875 L 2.515625 -2.125 C 2.515625 -1.757812 2.613281 -1.507812 2.8125 -1.375 C 3.007812 -1.25 3.304688 -1.1875 3.703125 -1.1875 Z M 3.765625 -1.1875 "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#000000",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(246.260527, 303.646213)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M -0.0625 0 C -0.113281 0 -0.140625 -0.0195312 -0.140625 -0.0625 L -0.140625 -1.109375 C -0.140625 -1.160156 -0.113281 -1.1875 -0.0625 -1.1875 L 1.484375 -1.1875 L 1.484375 -6.1875 L 2.84375 -6.1875 L 2.84375 0 Z M -0.0625 2.390625 L -0.0625 1.015625 L 1.203125 1.015625 L 1.203125 2.390625 Z M 1.546875 2.390625 L 1.546875 1.015625 L 2.8125 1.015625 L 2.8125 2.390625 Z M 1.546875 2.390625 "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#000000",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(250.12882, 303.646213)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 5.8125 -1.1875 C 5.851562 -1.1875 5.875 -1.160156 5.875 -1.109375 L 5.875 -0.0625 C 5.875 -0.0195312 5.851562 0 5.8125 0 L 0.125 0 L 0.125 -1.1875 L 3.109375 -1.1875 L 3.109375 -4.0625 C 3.109375 -4.425781 3.039062 -4.675781 2.90625 -4.8125 C 2.78125 -4.945312 2.578125 -5.015625 2.296875 -5.015625 L 1.390625 -5.015625 L 1.390625 -6.1875 L 2.296875 -6.1875 C 2.953125 -6.1875 3.472656 -6.003906 3.859375 -5.640625 C 4.253906 -5.273438 4.453125 -4.753906 4.453125 -4.078125 L 4.453125 -1.1875 Z M 5.8125 -1.1875 "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#000000",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(255.867632, 303.646213)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 3.359375 -6.296875 C 4.035156 -6.296875 4.566406 -6.101562 4.953125 -5.71875 C 5.347656 -5.34375 5.546875 -4.828125 5.546875 -4.171875 L 5.546875 -2.015625 C 5.546875 -1.347656 5.347656 -0.828125 4.953125 -0.453125 C 4.566406 -0.078125 4.035156 0.109375 3.359375 0.109375 C 2.992188 0.109375 2.675781 0.0507812 2.40625 -0.0625 C 2.144531 -0.175781 1.925781 -0.34375 1.75 -0.5625 C 1.269531 -0.1875 0.6875 0 0 0 L -0.0625 0 C -0.113281 0 -0.140625 -0.0195312 -0.140625 -0.0625 L -0.140625 -1.109375 C -0.140625 -1.160156 -0.113281 -1.1875 -0.0625 -1.1875 L 0 -1.1875 C 0.382812 -1.1875 0.675781 -1.25 0.875 -1.375 C 1.070312 -1.507812 1.171875 -1.765625 1.171875 -2.140625 L 1.171875 -5.96875 C 1.441406 -6.050781 1.773438 -6.125 2.171875 -6.1875 C 2.578125 -6.257812 2.972656 -6.296875 3.359375 -6.296875 Z M 4.203125 -2.015625 L 4.203125 -4.15625 C 4.203125 -4.507812 4.132812 -4.753906 4 -4.890625 C 3.863281 -5.035156 3.648438 -5.109375 3.359375 -5.109375 C 3.085938 -5.109375 2.804688 -5.082031 2.515625 -5.03125 L 2.515625 -2.015625 C 2.515625 -1.671875 2.578125 -1.425781 2.703125 -1.28125 C 2.835938 -1.132812 3.054688 -1.0625 3.359375 -1.0625 C 3.648438 -1.0625 3.863281 -1.132812 4 -1.28125 C 4.132812 -1.425781 4.203125 -1.671875 4.203125 -2.015625 Z M 4.203125 -2.015625 "
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "#000000",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M -0.000902184 0.497792 L 118.118907 0.497792 ",
    transform: "matrix(0.749305,0,0,0.749305,17.645207,301.150439)"
  }), /*#__PURE__*/React.createElement("g", {
    clipRule: "nonzero",
    clipPath: "url(#8591b11679)"
  }, /*#__PURE__*/React.createElement("g", {
    clipRule: "nonzero",
    clipPath: "url(#821fe50ce5)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#000000",
      fillOpacity: 1
    },
    d: "M 116.835938 66.265625 L 258.417969 66.265625 L 258.417969 207.292969 L 116.835938 207.292969 Z M 116.835938 66.265625 "
  }))), /*#__PURE__*/React.createElement("g", {
    clipRule: "nonzero",
    clipPath: "url(#13e4c096a6)"
  }, /*#__PURE__*/React.createElement("g", {
    clipRule: "nonzero",
    clipPath: "url(#7ea3d3c2cb)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#000000",
      fillOpacity: 1
    },
    d: "M 116.835938 66.265625 L 258.417969 66.265625 L 258.417969 207.292969 L 116.835938 207.292969 Z M 116.835938 66.265625 "
  }))), /*#__PURE__*/React.createElement("g", {
    clipRule: "nonzero",
    clipPath: "url(#8393e8b967)"
  }, /*#__PURE__*/React.createElement("g", {
    clipRule: "nonzero",
    clipPath: "url(#90cc1ebfbb)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#000000",
      fillOpacity: 1
    },
    d: "M 116.835938 66.265625 L 258.417969 66.265625 L 258.417969 207.292969 L 116.835938 207.292969 Z M 116.835938 66.265625 "
  }))), /*#__PURE__*/React.createElement("g", {
    clipRule: "nonzero",
    clipPath: "url(#40136134e2)"
  }, /*#__PURE__*/React.createElement("g", {
    clipRule: "nonzero",
    clipPath: "url(#a05647cd8a)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#000000",
      fillOpacity: 1
    },
    d: "M 116.835938 66.265625 L 258.417969 66.265625 L 258.417969 207.292969 L 116.835938 207.292969 Z M 116.835938 66.265625 "
  }))), /*#__PURE__*/React.createElement("g", {
    clipRule: "nonzero",
    clipPath: "url(#0650b26240)"
  }, /*#__PURE__*/React.createElement("g", {
    clipRule: "nonzero",
    clipPath: "url(#927ef27039)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#000000",
      fillOpacity: 1
    },
    d: "M 116.835938 66.265625 L 258.417969 66.265625 L 258.417969 207.292969 L 116.835938 207.292969 Z M 116.835938 66.265625 "
  }))), /*#__PURE__*/React.createElement("g", {
    clipRule: "nonzero",
    clipPath: "url(#cb0cd4c986)"
  }, /*#__PURE__*/React.createElement("g", {
    clipRule: "nonzero",
    clipPath: "url(#29c1f1c9d2)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#000000",
      fillOpacity: 1
    },
    d: "M 116.835938 66.265625 L 258.417969 66.265625 L 258.417969 207.292969 L 116.835938 207.292969 Z M 116.835938 66.265625 "
  }))), /*#__PURE__*/React.createElement("g", {
    clipRule: "nonzero",
    clipPath: "url(#9b1fec5206)"
  }, /*#__PURE__*/React.createElement("g", {
    clipRule: "nonzero",
    clipPath: "url(#672f7ab6be)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#000000",
      fillOpacity: 1
    },
    d: "M 116.835938 66.265625 L 258.417969 66.265625 L 258.417969 207.292969 L 116.835938 207.292969 Z M 116.835938 66.265625 "
  }))), /*#__PURE__*/React.createElement("g", {
    clipRule: "nonzero",
    clipPath: "url(#dfb7c18ed1)"
  }, /*#__PURE__*/React.createElement("g", {
    clipRule: "nonzero",
    clipPath: "url(#ba6d279379)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#000000",
      fillOpacity: 1
    },
    d: "M 116.835938 66.265625 L 258.417969 66.265625 L 258.417969 207.292969 L 116.835938 207.292969 Z M 116.835938 66.265625 "
  }))), /*#__PURE__*/React.createElement("g", {
    clipRule: "nonzero",
    clipPath: "url(#ef50f2a348)"
  }, /*#__PURE__*/React.createElement("g", {
    clipRule: "nonzero",
    clipPath: "url(#278409d6d6)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#000000",
      fillOpacity: 1
    },
    d: "M 116.835938 66.265625 L 258.417969 66.265625 L 258.417969 207.292969 L 116.835938 207.292969 Z M 116.835938 66.265625 "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoStationnement);
export default __webpack_public_path__ + "static/media/logo-stationnement.b7560b9eedcff7301c410974a2246a07.svg";
export { ForwardRef as ReactComponent };